import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
// import ReactPlayer from "react-player";
import { useAuth } from "../../context/AuthContext";
import useFetchCategories from "../../hooks/useFetchCategories";
import { PillLoader, BlobLoader } from "../../components/loader";
import { stopSpeech, stopSpeechTTS } from "../../utils/playSpeech";
import {
  IntroMessage,
  IncompleteMessage,
  ClickToListen,
  NextMessage,
} from "../../components/guidance";

import LayeredSVG from "./LayeredSVG";

import PrevBtn from "../../assets/images/prev.png";
import NextBtn from "../../assets/images/next.png";
import SuccessBanner from "../../assets/images/success-banner.png";
import SuccessChar from "../../assets/images/GiF/Girl.gif";
import Fireworks from "../../assets/images/GiF/Fireworks.gif";
import GirlChar from "../../assets/images/title-girl.png";
import CorrectButtonPNG from "../../assets/images/correctButton.png";
import WrongButtonPNG from "../../assets/images/wrongButton.png";
import ReportsButtonPNG from "../../assets/images/reportsButton.png";
import VideoPlayer from "./VideoPlayer";
import { Fullscreen } from "lucide-react";
import "./style.css";
import ModalSound from "../../assets/audios/subtopic.wav";
import handGif from "../../assets/images/GiF/hand.gif";

function CategoriesPage({ handleClick }) {
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState(true);
  const [categories, loading, loadCategories, checkForLoadCtaegories] =
    useFetchCategories();
  const { auth, breadcrumbs } = useAuth();

  const role = auth?.user?.role?.toLowerCase();
  const isDeveloper = role === "developer";

  // const [videoDuration, setVideoDuration] = useState(0);
  // const [playedSeconds, setPlayedSeconds] = useState(0);
  const [lastTtlSecs, setLastTtlSecs] = useState(null);
  const [currentSection, setCurrentSection] = useState(0);
  const [sectionCompleted, setSectionCompleted] = useState([]);
  const [overlayStep, setOverlayStep] = useState([]);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [showCursorOverlay, setShowCursorOverlay] = useState([]);
  const { setCommonWarning, setCommonError, selectedLang } = useAuth();
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isGameActive, setIsGameActive] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const [gameSubmissionWarning, setGameSubmissionWarning] = useState(false);
  const [gameCompleted, setGameCompleted] = useState(false);
  const [showHandGuide, setShowHandGuide] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  const [pageLoading, setPageLoading] = useState(false);
  const toggleFullScreen = () => {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      elem
        .requestFullscreen()
        .then(() => setIsFullScreen(true))
        .catch((err) =>
          console.warn(`Error enabling full-screen: ${err.message}`),
        );
    } else {
      document
        .exitFullscreen()
        .then(() => setIsFullScreen(false))
        .catch((err) =>
          console.warn(`Error exiting full-screen: ${err.message}`),
        );
    }
  };
  const requestFullscreenCompat = (element) => {
    if (element.requestFullscreen) {
      return element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      return element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      return element.mozRequestFullScreen();
    } else if (element.msRequestFullscreen) {
      return element.msRequestFullscreen();
    }
  };
  // const reactPlayerRef = useRef(null);
  const highlightRef = useRef(null);
  const activityRefs = useRef([]);
  const sectionsRefs = useRef([]);

  const videoURL = "https://file.fefdygo.com/";

  // ====== Extract IDs from breadcrumbs ======
  const subjectId = breadcrumbs.find((i) => i.path === "/levels")?.id || null;
  const levelId = breadcrumbs.find((i) => i.path === "/topics")?.id || null;
  const topicId = breadcrumbs.find((i) => i.path === "/subtopics")?.id || null;
  const subtopicId =
    breadcrumbs.find((i) => i.path === "/categories")?.id || null;
  const subtopicName =
    breadcrumbs.find((i) => i.path === "/categories")?.title || null;

  // ====== Loader delay ======
  useEffect(() => {
    const timer = setTimeout(() => setShowLoader(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const handleChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleChange);
    return () => document.removeEventListener("fullscreenchange", handleChange);
  }, []);

  // ====== Initialize sections and overlays ======
  const [nextIsHandled, setNextIsHandled] = useState(false);

  // ====== Adjust highlight position ======
  useEffect(() => {
    if (highlightRef.current && activityRefs.current[currentSection]) {
      highlightRef.current.style.top =
        activityRefs.current[currentSection].offsetTop + "px";
    }
  }, [currentSection]);

  // ====== Manage z-index layering ======
  useEffect(() => {
    const header = document.querySelector(".header");
    const breadcrumbs = document.querySelector(".breadcrumbs");
    const helper = document.querySelector(".helper");
    const currentStep = overlayStep[currentSection];
    const showCursor = showCursorOverlay[currentSection];
    const langDropdown = document.querySelector(".custom-language-menu");

    let zIndex;
    if (currentStep === 1) {
      zIndex = "5";
    } else if (currentStep === 2) {
      zIndex = "20";
    } else if (currentStep === 3 && showCursor) {
      zIndex = "5";
    } else if (currentStep === 3) {
      zIndex = "20";
    } else {
      zIndex = "10";
    }

    if (header) header.style.zIndex = zIndex;
    if (helper) helper.style.zIndex = zIndex;
    if (breadcrumbs) breadcrumbs.style.zIndex = zIndex - 2;
    if (langDropdown) langDropdown.style.zIndex = zIndex - 1;
    // console.log("Set zIndex to:", zIndex);
    // console.log("header zIndex:", header ? header.style.zIndex : "N/A");
    // console.log(
    //   "breadcrumbs zIndex:",
    //   breadcrumbs ? breadcrumbs.style.zIndex : "N/A"
    // );
    // console.log(
    //   "langDropdown zIndex:",
    //   langDropdown ? langDropdown.style.zIndex : "N/A"
    // );
  }, [overlayStep, currentSection, showCursorOverlay]);

  useEffect(() => {
    const currentStep = overlayStep[currentSection];
    let isDialogShowed = localStorage.getItem("isIntroDialogShowed")
      ? localStorage.getItem("isIntroDialogShowed").split(",").map(Number)
      : [];

    const isOverlayRendering =
      currentStep !== undefined &&
      currentStep > 0 &&
      currentStep < 2 &&
      !isDialogShowed.includes(currentSection);

    const gameContent = sectionsRefs.current[currentSection]?.querySelector(
      ".game-section-content",
    );

    if (isOverlayRendering && currentSection !== null) {
      if (gameContent) {
        gameContent.style.pointerEvents = "none";
      }
    } else {
      if (gameContent) {
        gameContent.style.pointerEvents = "auto";
      }
    }

    return () => {
      if (gameContent) {
        gameContent.style.pointerEvents = "auto";
      }
    };
  }, [overlayStep, currentSection]);

  useEffect(() => {
    if (showSuccess) {
      stopSpeech();
      stopSpeechTTS();
      // console.log("🎉 Success modal shown - all guidance audio stopped");
    }
  }, [showSuccess]);

  // ====== Utility functions ======
  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(secs % 60)
      .toString()
      .padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  // const formatYoutubeUrl = (url) => {
  //   if (url.includes("shorts/")) return url.replace("shorts/", "watch?v=");
  //   if (url.includes("embed/")) return url.replace("embed/", "watch?v=");
  //   return url;
  // };
  // console.log(subtopicName);
  // ====== API call for play history ======
  const playSeconds = async (
    ttl_secs,
    play_secs,
    status,
    subtopic,
    category,
    subtopic_data,
    N,
  ) => {
    const ttl_seconds = ttl_secs ?? lastTtlSecs;
    if (ttl_secs && ttl_secs > 0) setLastTtlSecs(ttl_secs);

    const play_seconds = play_secs ?? 0;
    const ttlFormatted = formatTime(ttl_seconds);
    const playFormatted = formatTime(play_seconds);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}history-entry`,
        {
          token: auth.token,
          subtopic,
          category,
          subtopic_data,
          ttl_time: ttlFormatted,
          seen_time: playFormatted,
        },
      );

      const resData = res.data;
      if (![200, 400, 401, 500].includes(resData.status)) {
        console.error("Unexpected response:", resData);
      }
    } catch (error) {
      console.error("Error sending playSeconds:", error);
    }
  };

  // ====== Handlers ======
  const handlePrev = () => {
    setPageLoading(true);
    if (currentSection > 0) {
      setCurrentSection((prev) => prev - 1);
    }
  };
  const [perLvlCompleted, setPerLvlCompleted] = useState(false);
  const [firstIncompleteIndexIND, setFirstIncompleteIndexIND] = useState(false);
  const [tempArray, setTempArray] = useState(false);
  const [finalSucces, setFinalSucces] = useState(false);
  // const handleNext = async () => {
  //   setNextIsHandled(true);
  //   const updatedCats = await loadCategories();
  //   const tempArr = updatedCats.map((val) => val?.is_completed === 1);
  //   // setSectionCompleted(tempArr);

  //   const firstIncompleteIndex = tempArr.findIndex((c) => !c);
  //   if (!tempArr[currentSection]) {
  //     setTimeout(() => {
  //       setShowPopup(true);
  //     }, 2000);
  //     return;
  //   }

  //   setFirstIncompleteIndexIND(firstIncompleteIndex);

  //   setPerLvlCompleted(true);
  //   // setCurrentSection((prev) => prev + 1);
  //   if (firstIncompleteIndexIND === -1) {
  //     // console.log("First incomplete index:", firstIncompleteIndexIND);
  //     setCurrentSection(tempArr.length - 1);
  //   }
  // };

  const [subCompleteModalShow, setSubCompleteModalShow] = useState(
    localStorage.getItem("sub_complete_modal_show") || "true",
  );

  useEffect(() => {
    if (nextIsHandled) {
      setNextIsHandled(false);
      return;
    }

    const tempArr = categories.map((val) => val?.is_completed === 1);
    setSectionCompleted(tempArr);

    const overlayArr = categories.map((val) => (val?.id ? 0 : -1));
    setOverlayStep(overlayArr);

    const cursorArr = categories.map((val) => (val?.id ? false : -1));
    setShowCursorOverlay(cursorArr);

    const firstIncompleteIndex = tempArr.findIndex((c) => !c);

    if (isDeveloper) {
      // Developer can access categories in any order.
      // Do not force them to the first incomplete category.
      setShowSuccess(false);

      // Only set the initial section if there is no valid current section yet.
      if (isInitialLoad) {
        setCurrentSection(0);
      }
    } else if (firstIncompleteIndex === -1) {
      setCurrentSection(tempArr.length - 1);

      if (!isInitialLoad) {
        setShowSuccess(true);
      }
    } else {
      setShowSuccess(false);
      setCurrentSection(firstIncompleteIndex);
    }

    setIsInitialLoad(false);
    setNextIsHandled(false);
  }, [categories]);
  useEffect(() => {
    if (!pageLoading) return;
    if (loading || showLoader) return;

    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 500); // adjust to 300-800ms if needed

    return () => clearTimeout(timer);
  }, [currentSection, loading, showLoader, pageLoading]);
  useEffect(() => {
    if (showSuccess && subCompleteModalShow === "true") {
      const modalAudio = new Audio(ModalSound);
      modalAudio.volume = 0.7;
      modalAudio.play().catch((err) => {
        console.error("Modal audio play failed:", err);
      });
    }
  }, [showSuccess, subCompleteModalShow]);

  useEffect(() => {
    const iframe = document.querySelector(".responsive-iframe");

    if (!iframe?.contentWindow) return;

    const overlayVisible =
      showPopup || gameSubmissionWarning || perLvlCompleted || showSuccess;

    // (overlayStep[currentSection] >= 0 && overlayStep[currentSection] < 2);

    console.log("Overlay states:", {
      showPopup,
      gameSubmissionWarning,
      perLvlCompleted,
      showSuccess,
      overlayStep: overlayStep[currentSection],
    });

    console.log("Sending:", overlayVisible ? "GAME_PAUSE" : "GAME_RESUME");

    iframe.contentWindow.postMessage(
      {
        action: overlayVisible ? "GAME_PAUSE" : "GAME_RESUME",
      },
      "*",
    );
  }, [
    showPopup,
    gameSubmissionWarning,
    perLvlCompleted,
    showSuccess,
    overlayStep,
    currentSection,
  ]);

  const handleNext = async (opts) => {
    const fromGameSubmit = opts?.fromGameSubmit === true;
    if (isDeveloper) {
      if (currentSection < categories.length - 1) {
        setPageLoading(true);
        setCurrentSection((prev) => prev + 1);
      } else {
        setShowSuccess(true);
      }

      return;
    }
    if (categories[currentSection]?.type === "game") {
      // Game not finished yet -> normal incomplete popup (NOT the "click Next inside the game" one)
      const alreadyCompleted =
        sectionCompleted[currentSection] ||
        categories[currentSection]?.is_completed === 1;

      if (!fromGameSubmit && !gameCompleted && !alreadyCompleted) {
        console.log("Game not completed yet - showing normal incomplete popup");
        const iframe = document.querySelector(".responsive-iframe");
        iframe?.contentWindow?.postMessage({ action: "GAME_PAUSE" }, "*");
        setGameSubmissionWarning(false);
        setShowPopup(true);
        return;
      }

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_ADMIN_URL}admin/activity/questions/check-history`,
          {
            ust: auth.token,
            sid: subjectId,
            lid: levelId,
            tid: topicId,
            stid: subtopicId,
            qid: categories[currentSection].id,
          },
        );

        console.log("Checking game submission...");
        console.log(res.data);

        if (!res.data.submitted) {
          console.log(
            "Game completed, but internal Next button was not clicked.",
          );

          const iframe = document.querySelector(".responsive-iframe");

          iframe?.contentWindow?.postMessage({ action: "GAME_PAUSE" }, "*");

          setGameSubmissionWarning(true);
          return;
        }
      } catch (err) {
        console.error(err);
        return;
      }
    }
    localStorage.setItem("sub_complete_modal_show", "true");
    setSubCompleteModalShow("true");
    setNextIsHandled(true);

    const updatedCats = await checkForLoadCtaegories();
    console.log("Updated categories:", updatedCats);
    const tempArr = updatedCats.map((val) => val?.is_completed === 1);
    console.log("Completion array:", tempArr);
    console.log("Current section:", currentSection);
    console.log("Current completed:", tempArr[currentSection]);
    setTempArray(tempArr);

    if (categories[currentSection].type === "game") {
      setSectionCompleted(tempArr);
    } else {
      await loadCategories();
      setSectionCompleted(tempArr);
    }
    const firstIncompleteIndex = tempArr.findIndex((c) => !c);
    setFirstIncompleteIndexIND(firstIncompleteIndex);

    // CASE 1: current section not completed → show popup, no loader
    if (!tempArr[currentSection]) {
      setTimeout(() => setShowPopup(true), 500);
      return;
    }

    // CASE 2: completed, but others incomplete ahead → show "next" popup, no loader yet
    if (firstIncompleteIndex !== -1 && currentSection < tempArr.length - 1) {
      setPerLvlCompleted(true);
      return;
    }

    // CASE 3: all completed → actually moving sections, show loader
    if (firstIncompleteIndex === -1) {
      setPageLoading(true); // moved here — only fires on a real section change
      setCurrentSection((prev) => {
        if (prev < tempArr.length - 1) return prev + 1;
        return prev;
      });
      if (!finalSucces && tempArr.length - 1 === currentSection) {
        setShowSuccess(true);
        setFinalSucces(true);
      }
      if (finalSucces && tempArr.length - 1 === currentSection) {
        setShowSuccess(true);
        setFinalSucces(true);
      }
      return;
    }
  };
  // ====== Guided reading: "No" = this category is done, continue ======
  const readingCompletionHandledRef = useRef(false);

  const handleReadingCategoryNext = async () => {
    localStorage.setItem("sub_complete_modal_show", "true");
    setSubCompleteModalShow("true");
    setNextIsHandled(true); // stops the [categories] effect reverting our local completion

    const updatedCats = await checkForLoadCtaegories();
    console.log(
      "Reading: backend is_completed for current category =",
      updatedCats?.[currentSection]?.is_completed,
    );

    // Force the current reading category to true; keep real backend values for the rest
    const tempArr = updatedCats.map(
      (val, index) => index === currentSection || val?.is_completed === 1,
    );
    setTempArray(tempArr);
    setSectionCompleted(tempArr);

    const firstIncompleteIndex = tempArr.findIndex((c) => !c);
    setFirstIncompleteIndexIND(firstIncompleteIndex);

    // Same outcomes as handleNext CASE 2 / CASE 3
    if (firstIncompleteIndex !== -1 && currentSection < tempArr.length - 1) {
      setPerLvlCompleted(true); // existing "well done → next" overlay
      return;
    }
    if (firstIncompleteIndex === -1) {
      if (currentSection < tempArr.length - 1) {
        setPageLoading(true);
        setCurrentSection((prev) => prev + 1);
      } else {
        setShowSuccess(true); // existing success modal
        setFinalSucces(true);
      }
    }
  };

  const handleReadingCompleteNo = async () => {
    if (isDeveloper) {
      handleNext(); // developer flow stays exactly as it was
      return;
    }
    if (readingCompletionHandledRef.current) return; // double-click guard
    readingCompletionHandledRef.current = true;

    console.log("Reading completed - user selected No");

    // Checkbox turns on immediately, before any backend work
    setSectionCompleted((prev) => {
      const updated = [...prev];
      updated[currentSection] = true;
      return updated;
    });

    try {
      await handleReadingCategoryNext();
    } catch (err) {
      console.error("Reading completion failed:", err);
    } finally {
      readingCompletionHandledRef.current = false;
    }
  };

  const handleOverlayClick = (index) => {
    const updated = [...overlayStep];
    if (updated[index] < 2) {
      updated[index] += 1;
      setOverlayStep(updated);
    }
  };

  const handleCursorClick = (index) => {
    stopSpeech();
    stopSpeechTTS();
    const updated = [...showCursorOverlay];
    updated[index] = true;
    setShowCursorOverlay(updated);
    const steps = [...overlayStep];
    steps[index] = 3; // terminal/completed
    setOverlayStep(steps);
  };

  // ====== Overlay Renderer ======
  const renderOverlay = (index, isActive) => {
    // Don't render any overlay if success modal is showing
    if (showSuccess) {
      return null;
    }

    const step = overlayStep[index];
    const showCursor = showCursorOverlay[index];

    let isDialogShowed = localStorage.getItem("isIntroDialogShowed")
      ? localStorage.getItem("isIntroDialogShowed").split(",").map(Number)
      : [];
    const isIntroDialogShowed = [...isDialogShowed];

    const addDialogIndex = () => {
      if (!isIntroDialogShowed.includes(index)) {
        isIntroDialogShowed.push(index);
        localStorage.setItem(
          "isIntroDialogShowed",
          isIntroDialogShowed.join(","),
        );
      }
    };

    // Show intro message for all types
    if (step === 0 && index === 0 && !isDialogShowed.includes(index))
      return (
        <div
          className="guidance-overlay guidance-overlay-full"
          onClick={() => {
            handleOverlayClick(index);
            stopSpeech();
            stopSpeechTTS();
          }}
        >
          <div className="guidance-content">
            <IntroMessage
              description={categories[index].description}
              audioFile={categories[index].intro_audio}
              subtopicName={subtopicName}
              isActive={isActive && !showSuccess} // Pass false if success modal is showing
            />
          </div>
        </div>
      );

    // Show "Click to Listen" ONLY for PDF type
    if (step === 1 && !isDialogShowed.includes(index)) {
      const isPDF = categories[index]?.type?.toLowerCase() === "pdf";

      if (isPDF) {
        return (
          <div
            className="guidance-overlay guidance-overlay-behind"
            onClick={() => {
              handleOverlayClick(index);
              stopSpeech();
              stopSpeechTTS();
            }}
          >
            <div className="guidance-content">
              <ClickToListen isActive={isActive && !showSuccess} />
            </div>
          </div>
        );
      } else {
        // For non-PDF, skip this step automatically
        addDialogIndex();
        return null;
      }
    }

    addDialogIndex();
    localStorage.setItem("isIntroDialogShowed", []);
    return null;
  };

  const parseTimeToSeconds = (timeString) => {
    if (!timeString) return 0;
    const parts = timeString.split(":").map(Number);
    if (parts.length === 3) {
      // HH:MM:SS
      const [h, m, s] = parts;
      return h * 3600 + m * 60 + s;
    } else if (parts.length === 2) {
      // MM:SS
      const [m, s] = parts;
      return m * 60 + s;
    }
    return 0;
  };

  // Fresh game state for every category change (sidebar, Prev, Next, popups, restart)
  useEffect(() => {
    setGameCompleted(false);
    setGameSubmissionWarning(false);
  }, [currentSection]);

  useEffect(() => {
    function receiveMessage(event) {
      console.log("iframe message:", event.origin, event.data);
      if (event.data?.action === "GAME_SUBMITTED") {
        setGameSubmissionWarning(false);
        setGameCompleted(false);

        if (document.fullscreenElement) {
          document.exitFullscreen();
        }

        handleNext({ fromGameSubmit: true });
      }
      if (event.data?.action === "GAME_COMPLETED") {
        console.log("GAME_COMPLETED received");
        setGameCompleted(true);
      }
    }

    window.addEventListener("message", receiveMessage);
    return () => window.removeEventListener("message", receiveMessage);
  }, [handleNext]);

  // ====== Render ======
  return (
    <div className="container">
      <div className="banner">
        <h2>{categories[currentSection]?.name}</h2>
      </div>

      <div className="game-bar">
        {/* ===== Sidebar ===== */}
        <div
          className={`game-side-bar ${isSidebarCollapsed ? "collapsed" : ""}`}
        >
          <button
            type="button"
            className="sidebar-toggle"
            onClick={() => setIsSidebarCollapsed((prev) => !prev)}
            aria-label={
              isSidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"
            }
          >
            {isSidebarCollapsed ? "›" : "‹"}
          </button>
          <div
            className={`game-header ${
              selectedLang?.code !== "en" ? "game-lang" : ""
            }`}
          >
            <h2>
              Let's get to know about our{" "}
              <span className="topic-title">{subtopicName}</span>
            </h2>
          </div>

          <div className="game-content">
            <div className="activity-list">
              <div className="highlight-pill" ref={highlightRef}></div>
              {categories.map((item, index) => (
                <div
                  key={index}
                  className={`activity-item ${
                    currentSection === index ? "active" : ""
                  }`}
                  {...((isDeveloper ||
                    sectionCompleted[index] ||
                    sectionCompleted[index - 1]) &&
                  !isGameActive
                    ? {
                        onClick: () => {
                          if (index === currentSection) return;

                          setPageLoading(true);
                          setCurrentSection(index);
                        },
                      }
                    : {})}
                  ref={(el) => (activityRefs.current[index] = el)}
                >
                  <div
                    className={`checkbox ${
                      sectionCompleted[index] ? "completed" : ""
                    }`}
                  />
                  <div className="activity-icon">
                    <img src={item.image} alt="Activity Icon" />
                  </div>
                  <div
                    className={`activity-text ${
                      selectedLang?.code !== "en" ? "act-lang" : ""
                    }`}
                  >
                    {item.name}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="game-topic-container">
            <p className="topictext-title bubble-topic">
              We are currently learning <span>{subtopicName}</span>
            </p>
            <img
              src={GirlChar}
              alt="Girl Character"
              className="girl-char-title"
            />
          </div>
        </div>

        <div className="button-wrapper">
          {/* ===== Main Game Area ===== */}
          <div className="game-content-box">
            <div style={{ position: "relative", minHeight: "600px" }}>
              {(loading || showLoader || pageLoading) && (
                <div className="content-loader">
                  <BlobLoader />
                </div>
              )}

              {!loading && !showLoader && !pageLoading && (
                <>
                  {/* Only render the current section */}
                  {(() => {
                    const section = categories[currentSection];
                    const index = currentSection;

                    if (!section) return null;

                    return (
                      <div
                        key={index}
                        className="game-section active"
                        ref={(el) => (sectionsRefs.current[index] = el)}
                      >
                        <button
                          id="fullscreen-btn"
                          className="fullscreen-btn"
                          onClick={() => {
                            const currentContent = document.querySelector(
                              `.game-section.active .game-section-content`,
                            );
                            const iframe =
                              currentContent?.querySelector(
                                ".responsive-iframe",
                              );

                            if (iframe) {
                              requestFullscreenCompat(iframe).catch((err) => {
                                console.warn(
                                  `Error requesting fullscreen: ${err.message}`,
                                );
                              });
                            } else {
                              requestFullscreenCompat(currentContent).catch(
                                (err) => {
                                  console.warn(
                                    `Error requesting fullscreen: ${err.message}`,
                                  );
                                },
                              );
                            }
                          }}
                        >
                          <Fullscreen />
                        </button>

                        <div className="game-section-content">
                          {/* ===== PDF Section ===== */}
                          {section?.type?.toLowerCase() === "pdf" && (
                            <LayeredSVG
                              src={
                                process.env.REACT_APP_PUBLIC_API_URL +
                                section?.value
                              }
                              category={section?.id}
                              subtopic_data={section?.valueid}
                              onReadingCompleteNo={handleReadingCompleteNo}
                            />
                          )}

                          {/* ===== Video Section ===== */}
                          {section?.type?.toLowerCase() === "video" &&
                            (section?.value ? (
                              section?.value?.includes("youtube.com") ||
                              section?.value?.includes("youtu.be") ? (
                                <video
                                  className="scroll video-wrapper"
                                  style={{ border: 0, width: "100%" }}
                                  controls
                                  preload="auto"
                                  autobuffer
                                  controlsList="nodownload"
                                  onPause={(e) =>
                                    playSeconds(
                                      Math.round(e.target.duration),
                                      Math.round(e.target.currentTime),
                                      "onpause",
                                      subtopicId,
                                      section?.id,
                                      section?.valueid,
                                    )
                                  }
                                  onEnded={(e) =>
                                    playSeconds(
                                      Math.round(e.target.duration),
                                      Math.round(e.target.currentTime),
                                      "onend",
                                      subtopicId,
                                      section?.id,
                                      section?.valueid,
                                    )
                                  }
                                >
                                  <source
                                    src="https://www.youtube.com/watch?v=gXv0uzLjgNw"
                                    type="video/mp4"
                                  />
                                  Your browser does not support the video tag.
                                </video>
                              ) : (
                                <VideoPlayer
                                  src={videoURL + section?.value}
                                  resumeTime={parseTimeToSeconds(
                                    section?.seen_time,
                                  )}
                                  onPause={(e) =>
                                    playSeconds(
                                      Math.round(e.target.duration),
                                      Math.round(e.target.currentTime),
                                      "onpause",
                                      subtopicId,
                                      section?.id,
                                      section?.valueid,
                                    )
                                  }
                                  onEnded={(e) =>
                                    playSeconds(
                                      Math.round(e.target.duration),
                                      Math.round(e.target.currentTime),
                                      "onend",
                                      subtopicId,
                                      section?.id,
                                      section?.valueid,
                                    )
                                  }
                                />
                              )
                            ) : (
                              <p>No video available</p>
                            ))}

                          {/* ===== Game Section ===== */}
                          {/* ===== Game Section ===== */}
                          {section?.type?.toLowerCase() === "game" && (
                            <>
                              {console.log("Section:", section)}
                              {console.log("Game URL:", section.value)}
                              <iframe
                                key={`game-${section?.id}-${index}`}
                                title={`game-frame-${section?.id ?? index}`}
                                className="responsive-iframe"
                                src={`${section.value}?sid=${subjectId}&lid=${levelId}&tid=${topicId}&stid=${subtopicId}&qid=${section?.id}&ust=${auth.token}`}
                                allow="microphone"
                                allowFullScreen
                              ></iframe>
                            </>
                          )}
                        </div>

                        {renderOverlay(index, true)}
                      </div>
                    );
                  })()}
                </>
              )}
            </div>
          </div>

          {/* ===== Navigation Buttons ===== */}
          <div className="game-button">
            <button onClick={handlePrev} disabled={currentSection === 0}>
              <img src={PrevBtn} alt="Previous Button" />
            </button>
            <button onClick={handleNext}>
              <img src={NextBtn} alt="Next Button" />
            </button>
          </div>
        </div>

        {/* ===== Popups ===== */}
        {showPopup && (
          <div
            className="popup-overlay"
            onClick={() => {
              setShowPopup(false);
              stopSpeech();
              stopSpeechTTS();

              const iframe = document.querySelector(".responsive-iframe");

              iframe?.contentWindow?.postMessage(
                { action: "GAME_RESUME" },
                "*",
              );
            }}
          >
            <div className="popup-box-dialogue">
              <IncompleteMessage isActive={!showSuccess} />{" "}
              {/* Don't play if success is showing */}
            </div>
          </div>
        )}
        {perLvlCompleted && firstIncompleteIndexIND !== -1 && (
          <div
            className="popup-overlay"
            onClick={() => {
              setSectionCompleted((prev) => {
                const updated = [...prev];
                updated[currentSection] = true;
                return updated;
              });
              setPerLvlCompleted(false);
              stopSpeech();
              stopSpeechTTS();
              if (firstIncompleteIndexIND !== -1) {
                setPageLoading(true);
                setCurrentSection((prev) => {
                  setGameCompleted(false);
                  if (prev < tempArray.length - 1) return prev + 1;
                  return prev;
                });
              } else {
                setShowSuccess(true);
              }
            }}
          >
            <div className="popup-box-dialogue">
              <NextMessage
                isActive={!showSuccess} // Don't play if success is showing
                audioFile={categories[currentSection]?.completion_audio}
                nextDescription={categories[currentSection + 1]?.name}
              />
            </div>
          </div>
        )}

        {showSuccess && subCompleteModalShow === "true" && (
          <div className="popup-overlay success-modal">
            <div className="kidsGameOverlay">
              <div className="kidsGameModal">
                <div className="kidsParticleContainer">
                  <div className="kidsConfettiParticle"></div>
                  <div className="kidsConfettiParticle"></div>
                  <div className="kidsConfettiParticle"></div>
                  <div className="kidsConfettiParticle"></div>
                  <div className="kidsConfettiParticle"></div>
                  <div className="kidsConfettiParticle"></div>
                </div>

                <h1 className="kidsMainHeading">Superb!</h1>
                <div className="kidsSubtitleText">
                  Level <span></span> of Explorer
                </div>

                <div className="kidsLevelBanner">
                  <div className="kidsLevelLabel">
                    You have completed the subtopic:
                  </div>
                  <div className="kidsLevelTitle">{subtopicName}</div>
                </div>

                <div className="kidsActionButtonGroup">
                  <button
                    className="kidsGameButton kidsRestartButton"
                    onClick={() => {
                      setShowSuccess(false);
                      setCurrentSection(0);
                      setPerLvlCompleted(false);
                      setShowPopup(false);
                      setFinalSucces(false);
                    }}
                  >
                    Restart
                  </button>
                  <button
                    className="kidsGameButton kidsNextButton"
                    onClick={() => navigate("/subtopics")}
                  >
                    Next
                  </button>
                </div>
                <div className="kidsReportButtonGroup">
                  <button
                    className="kidsGameButton kidsReportButton"
                    onClick={() =>
                      handleClick(subtopicId.id, "Reports", `/reports`)
                    }
                  >
                    Report
                  </button>
                </div>
              </div>
            </div>
            <img
              src={SuccessChar}
              alt="Success Character"
              className="success-char"
            />
            {/* <video
              src={SuccessChar}
              autoPlay
              loop
              className="success-char"
            ></video> */}
            <img src={Fireworks} alt="Fireworks" className="fireworks left" />
            <img src={Fireworks} alt="Fireworks" className="fireworks right" />
          </div>
        )}

        {gameSubmissionWarning && (
          <div
            className="popup-overlay"
            onClick={() => {
              setGameSubmissionWarning(false);
              stopSpeech();
              stopSpeechTTS();

              const iframe = document.querySelector(".responsive-iframe");
              iframe?.contentWindow?.postMessage(
                { action: "GAME_RESUME" },
                "*",
              );
            }}
          >
            <div className="popup-box-dialogue">
              <IncompleteMessage
                isActive
                message="Please click the Next button inside the game to save your progress before continuing."
              />
            </div>

            <img src={handGif} alt="Click Next" className="center-hand-guide" />
          </div>
        )}
      </div>
    </div>
  );
}

export default CategoriesPage;
